import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import ECard from "components/Dashboard/ECard";
import { ECardDownloadWrapper } from "./styles";

const ECardDownload = () => {
  // getting members state from router
  const { state } = useLocation();
  // getting members from the state
  const members = useMemo(() => {
    return state.data;
  }, [state]);

  return (
    <ECardDownloadWrapper>
      {members.map((member) => (
        <ECard noStrip member={member} />
      ))}
    </ECardDownloadWrapper>
  );
};

export default ECardDownload;
